import { useEffect, useState } from "react";

/**
 * Returnerar true först efter att klienthydreringen är klar. Används för
 * text som annars kan skilja sig mellan server och klient och ge en
 * hydration-mismatch.
 */
export function useHydrated(): boolean {
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => {
    setHydrated(true);
  }, []);
  return hydrated;
}
